import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentRatingsComponent } from './content-ratings.component';
import { SafePipe } from './safe.pipe';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {ContentViewsModule} from '../../content-views/content-views.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { RatingsService } from './../ratings.service';
import { reducers } from './../ngrx/reducers';
import { RatingsEffects } from './../ngrx/effects';

@NgModule({
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    ContentViewsModule,
    StoreModule.forFeature(RatingsService.featureName, reducers),
    EffectsModule.forFeature([RatingsEffects]),
  ],
  exports: [
    ContentRatingsComponent
      ],
  declarations: [ContentRatingsComponent, SafePipe],
  providers: [
    RatingsService
  ]
})
export class ContentRatingsModule { }
